module.exports = __webpack_public_path__ + "img/file-earmark-spreadsheet-fill.a34dd683.svg";